import React,{ useContext, useEffect, useState } from 'react'
//form components
import PlusIcon from "../../Images/Path 3979.svg"
import professionalIcon from '../../Images/Group 930@2x.png'
import Constants, { loginFrom, EventName, EventKeys } from "../../Constants/constants";
import { useTranslation } from "react-i18next";
import { LoginContext } from "../../Contexts/LoginContext";
import { ignoreSpaces, textAreaLimit } from '../../Constants/constants'
import RouteSegments from "../../Routes/RouteSegment";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

export default function DescriptionEsit(props) {
    const { loginDetail, logout } = useContext(LoginContext);

    const { t: trans } = useTranslation();
    const [isDisabled, setIsDisabled] = useState(false)

    const isCommunitySite = localStorage.getItem(Constants.loginLocalStorageKeys.isCommunitySite);
    const [autoDescription, setAutoDescription] = useState("");
 // When the auto description is set (from automation), store it
 useEffect(() => {
    if (props.values.description && autoDescription === "") {
      setAutoDescription(props.values.description);
    }
  }, [props.values.description, autoDescription]);
  const isEdited = props.values.description !== autoDescription;
  const navigate = useNavigate()



  return (
    <>
            <p className=" text-[#D63838] text-[25px]  p-3 ml-2 font-bold font-segeo">
              {trans('Add Hobbies & Interests in your description')}
              </p>
              <p className=" text-[#575556] lg:text-[18px] text-[15px] md:text-[15px] p-3 mb-3 ml-2 font-semibold font-segeo">
              Based on your profile details, we suggest the following description with your hobbies & interest. Stand out and attract your perfect match with a well-written profile description.
              You can also type your own by clicking the description box.
               </p>
        
            {/* <div className='mt-[1rem] rounded-[9px] md:rounded-[18px] border border-[#707070]'> */}
            <p className=" font-sans_book_body p-3  text-[12px] leading-[17pt] tracking-[-0.3pt] lg:text-[#333333] lg:text-[14px] lg:tracking-[-0.34px] lg:leading-[19px]  mt-3">
                {
                    <div className=''>

                    <div className="space-y-1">
                    <div>
                        <label className="relative block" name="description">
            
                            <textarea
                            id="description"
                            name="description"
                            value={props?.values?.description}
                            onChange={(e) => {
                                let text = e.target.value ?? "";
                                text = text.replace(/  +/g, " ")
                                e.target.value = text;
                                if (e.target.value?.length <= textAreaLimit) {
                                props?.onChange(e)
                                }
                            }}
                            readOnly={props?.values?.description?.length == textAreaLimit ? true : false}
                            // onKeyPress="return ignoreSpaces(event)"
                            onKeyDown={ignoreSpaces}
                            disabled={false}
                            className="h-40 basicInfo form-input shadow-sm  bg-[#FFFFFF] text-[#000000] text-[14px] md:text-[16px] lg:text-[15px] focus:outline-none rounded-[4px] focus:ring-[#2D2C6F] border-[1px] border-[#D9D9D9] lg:py-1 lg:px-1 md:py-3 md:px-3  py-5 px-5 w-full block ml-2"
                            >
                            </textarea>
                        
                        </label>
            
                        {props?.values?.description?.length > 0 &&
                        <p className="text-[red] text-[12px] mt-3">
                            {props?.values?.description?.length === textAreaLimit ?
                            "You have reached the limit of 999 characters" :
                            trans('registration.number_characters_left', { number: textAreaLimit - props?.values?.description?.length })
            
                            }
                        </p>
                        }
                    </div>
                    </div>
                    {/* <div className="space-x-2 flex mt-4">
                    <input
                        type="checkbox"
                        autoComplete="off"
                        id="isDescription"
                        name="isDescription"
                        value={props?.values?.isDescription}
                        checked={props?.values?.isDescription}
                        onChange={(e) => {
                        props?.onChange(e)
                        if (e.target.checked) {
                            setIsEnabled(false)
                        } else {
                            setIsEnabled(true)
                            props?.fValue?.setFieldValue("description", "", false);
                        }
                        }}
                        className="mr-3 mt-[0.1rem] relative top-[2px] h-[1.2rem] w-[1.2rem] accent-red-500 border border-[#F18181]"
                    />
                    <span className=" text-[14px] md:ml-[3px] lg:ml-[5px]">
                        Set this as Description
                    </span>
                    </div> */}
                </div>
                }
                </p>
            {/* </div> */}

            <div className="flex justify-between mt-5 mx-[1rem] md:mx-[4rem] lg:mx-[4rem] mb-[4rem]">
              <div className="pl-0 md:pl-[4rem]lg:pl-[4rem]">
                <button 
                onClick={() => props.onSubmitDescription(props.values.description, isEdited)}
                className={`text-[14px]  text-white lg:px-[2.5rem] md:px-[2.5rem] px-[1.5rem] py-2.5 rounded-md ${isDisabled ? "bg-[#DA3535] opacity-50" : "bg-[#DA3535]"}`} disabled={isDisabled}>{trans('registration.submit__continue')}</button>
              </div>

              {isCommunitySite
                ? null
                : <div className="">
                  <button
                    onClick={() => {
                      if (isCommunitySite) {
                        if (localStorage.getItem("submitpref")) {
                          localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegments.PAYMENT_PAGE)
                          sessionStorage.setItem(Constants.loginLocalStorageKeys.paymentPage,"true")
                          navigate(RouteSegments.PAYMENT_PAGE)
                        } else {
                          alert("Please Select any hobbies")
                        }

                      } else {
                        localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegments.PAYMENT_PAGE)
                        sessionStorage.setItem(Constants.loginLocalStorageKeys.paymentPage,"true")
                        navigate(RouteSegments.PAYMENT_PAGE)
                      }
                    }}
                    type="button" className="cursor-pointer pt-2 text-[#C1C1C1] text-[13px] underline">{trans('kalyan_rewards_popup.skip')}</button>
                </div>}

            </div>


    </>
  

  )
}
